import store from "@/store";

export default {
    toPrettyDate(d) {
        let days = ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"];
        var pad = function (num) { return ('00' + num).slice(-2) };
        let date = new Date(d);
        date = days[date.getDay()] + " " + pad(date.getUTCDate()) + '/' +
            pad(date.getUTCMonth() + 1) + '/' +
            date.getUTCFullYear();
        return date;
    },
    displayMenu() {
        if (window.innerWidth >= 1660) {
            store.commit('toggleMenu', true);
        } else {
            store.commit('toggleMenu', false);
        }
    },
    validEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    validUsername(username) {
        let re = /^[a-z0-9_-]{3,16}$/;
        return re.test(username);
    },
    validSwissTel(tel) {
        let re = /^(0041|041|\+41|\+\+41|41)?(0|\(0\))?([1-9]\d{1})(\d{3})(\d{2})(\d{2})$/;
        return re.test(tel);
    },
    decimalToHour(decimal) {
        return `${String((Math.floor(decimal))).padStart(2, '0')}h${String(Math.floor((decimal - Math.floor(decimal)) * 60)).padStart(2, '0')}`;
    }
}